import { useEffect } from "react";
import { useSetRecoilState } from "recoil";

import { specificTableRowIdsRenderedAtom } from "@ryde/shared";

export const useRegisterSpecificTableRowId = (
  rowId: number,
  enabled = true,
): void => {
  const setRenderedRowIds = useSetRecoilState(specificTableRowIdsRenderedAtom);

  useEffect(() => {
    if (!enabled || !rowId) {
      return undefined;
    }

    setRenderedRowIds(previousIds => {
      if (previousIds.has(rowId)) {
        return previousIds;
      }

      const nextIds = new Set(previousIds);
      nextIds.add(rowId);
      return nextIds;
    });

    return () => {
      setRenderedRowIds(previousIds => {
        if (!previousIds.has(rowId)) {
          return previousIds;
        }

        const nextIds = new Set(previousIds);
        nextIds.delete(rowId);
        return nextIds;
      });
    };
  }, [enabled, rowId, setRenderedRowIds]);
};
